module.exports = __webpack_public_path__ + "static/media/JadeEPalaceWalkwayEXTA0032_design_clean_v001.648dfef2.webp";